import { NewsletterSource }              from '../../mediego-common-module/declarations/source';
import { NewsletterPermissions } from '../declarations/engine';

export class AuthUtils {

  static getDefaultRouteOfNewsletter(source: NewsletterSource, perms: NewsletterPermissions): string {

    if (!source && !perms) {
      return '/newsletters/';
    }

    if (perms) {

      if (perms.editTemplate && source.enableTemplateEditor) {
        return `/newsletters/${perms.newsletterId}/edit-template`;
      } else if (perms.editContent) {
        return `/newsletters/${perms.newsletterId}/edit-content`;
      } else if (perms.editVariables) {
        return `/newsletters/${perms.newsletterId}/edit-variables`;
      } else if (perms.editCampaigns) {
        return `/newsletters/${perms.newsletterId}/edit-campaigns`;
      } else if (perms.statistics) {
        return `/newsletters/${perms.newsletterId}/stats`;
      } else if (perms.configuration) {
        return `/newsletters/${perms.newsletterId}/setup`;
      } else {
        return '/';
      }

    } else {
      return '/';
    }
  }
}
